import { useEffect } from "react";
import useAudioPlayerStore from "src/stores/useAudioPlayerStore";

const AudioPlayerSource = ({
	audioUrl,
	thumbnailUrl,
}: {
	audioUrl: string;
	thumbnailUrl: string;
}) => {
	useEffect(() => {
		const unsubscribe = useAudioPlayerStore.getState().createAudio({
			audioUrl,
			thumbnailUrl,
		});

		return () => {
			unsubscribe();
		};
	}, [audioUrl, thumbnailUrl]);

	return null;
};
export default AudioPlayerSource;
